<template>
  <div class="user-management">
    <div class="d-flex wrap gap-10">
      <!-- 国家 -->
      <div class="d-flex">
        <label class="mr5">国家</label>
        <el-select
          class="input200"
          v-model="queryParams.country"
          clearable
          @change="changeCountry"
        >
          <el-option
            v-for="item in countries"
            :key="item.code"
            :label="item.name"
            :value="item.code">
          </el-option>
        </el-select>
      </div>
      <!-- 省 -->
      <div class="d-flex">
        <label class="mr5">省/直辖市</label>
        <el-select
          class="input200"
          v-model="queryParams.province"
          clearable
          @change="
            queryParams.city = undefined
            queryParams.area = undefined
            getCityOpts()
          "
        >
          <el-option
            v-for="item in addressOptions"
            :key="item.code"
            :label="item.name"
            :value="item.code"
          >
          </el-option>
        </el-select>
      </div>
      <!-- 市 -->
      <div class="d-flex">
        <label class="mr5">市</label>
        <el-select
          class="input200"
          clearable
          v-model="queryParams.city"
          :disabled="!queryParams.province"
          @change="$forceUpdate()"
        >
          <el-option
            v-for="item in cityOpts"
            :key="item.code"
            :label="item.name"
            :value="item.code"
          >
          </el-option>
        </el-select>
      </div>

      <!-- 县 -->
      <!-- <div class="d-flex">
        <label class="mr5">区/县/地级市</label>
        <el-select
          class="input200"
          v-model="queryParams.area"
          :disabled="!queryParams.city"
          remote
          filterable
          clearable
          @change="$forceUpdate()"
        >
          <el-option
            v-for="item in areaOpts"
            :key="item.code"
            :label="item.name"
            :value="item.name"
          >
          </el-option>
        </el-select>
      </div> -->
      <!-- 经销商名称 -->
      <div class="d-flex">
        <label class="mr5">经销商名称</label>
        <!-- <el-cascader
          clearable
          :options="dealerOptions"
          v-model="queryParams.id"
          :props="{
            label: 'name',
            value: 'id',
            emitPath: false,
          }"
          :show-all-levels="false"
        ></el-cascader> -->
        <!-- <el-select
          class="input200"
          v-model="queryParams.id"
          remote
          filterable
          clearable
        >
          <el-option
            v-for="item in dealerOptions"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select> -->
        <el-autocomplete
          v-model="queryParams.name"
          value-key="name"
          :fetch-suggestions="getDealerSelect"
          :placeholder="`请选择`"
          clearable
        >
        </el-autocomplete>
      </div>

      <el-button class="ml10" type="primary" size="small" @click="search">{{
        `查询`
      }}</el-button>

      <el-button v-if="user.role_id === 1" class="ml10" type="primary" size="small" @click="openCreate">{{
        `新建`
      }}</el-button>

      <el-button v-if="user.role_id === 1" class="ml10" type="danger" size="small" @click="batchDel">{{
        `批量删除`
      }}</el-button>

      <el-button
        class="ml10"
        type="warning"
        size="small"
        @click="handleImrort"
        >导入</el-button
      >

      <el-button class="ml10" size="small" @click="handleExport">{{
        `导出`
      }}</el-button>
    </div>

    <div class="page-card">
      <el-table
        class="mt10"
        border
        @sort-change="sortChange"
        :data="list"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection"></el-table-column>
        <el-table-column type="index" label="#"></el-table-column>
        <el-table-column
          v-for="item in headers"
          :key="item.id"
          :type="item.type"
          :label="item.label"
          :prop="item.prop"
          :width="item.width"
        >
          <template slot-scope="scope">
            <template v-if="item.prop === 'handle'">
              <el-button type="text" @click="openView(scope.row)">
                查看
              </el-button>

              <el-button v-if="user.role_id === 1" type="text" @click="openEdit(scope.row)">
                修改
              </el-button>

              <el-popconfirm
                :title="`是否确认删除`"
                @confirm="handleDel(scope.row)"
                style="margin-left: 10px"
              >
                <el-button v-if="user.role_id === 1" type="text" slot="reference">
                  删除
                </el-button>
              </el-popconfirm>
            </template>
            <span v-else>{{ scope.row[item.prop] }}</span>
          </template>
        </el-table-column>
      </el-table>
      <pagination :queryParams="queryParams" :getList="getList" />
    </div>

    <edit ref="edit" @success="operationSuccessful" />
    <!-- 导入文件 -->

    <ImportFile
      :link="'/template/basic/dealer/经销商管理.xlsx'"
      ref="importFile"
      @complete="getImport"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import store from '@/store'
import Pagination from '@/components/common/Pagination'
import {
  dealerList,
  dealerSelect,
  delDealer,
  importDealer,
} from '@/api.js'
import {
    getAddressData
} from '@/requests/system'
import { pageSize } from '@/utils/Config.js'
import edit from './components/edit'
import ImportFile from '@/components/common/ImportFile.vue'
export default {
  name: 'UserManagement',
  components: {
    Pagination,
    edit,
    ImportFile,
  },
  computed: {
    ...mapGetters(['user', 'countries']),
    // cityOpts() {
    //   const { province } = this.queryParams

    //   const p = this.addressOptions.find((i) => i.code === province)
    //   if (!p) {
    //     return []
    //   } else {
    //     return p.children || []
    //   }
    // },
  },
  data() {
    return {
      queryParams: {
        pageIndex: 1,
        pageSize,
        _total: 0,
      },
      userOpts: [],
      headers: [],
      list: [],
      areaOpts: [], //区县list
      dealerOptions: [], //经销商下拉列表
      selection: [],
      cityOpts: [],
      addressOptions: [],
    }
  },
  methods: {
    // 操作成功时：
    operationSuccessful(){
      this.getList()
      // this.getDealerSelect() // 更新经销商的数据
    },
    getList() {
      const { province, city, area, name, pageIndex, pageSize, country } = this.queryParams
      const query = {
        province,
        city,
        area,
        name,
        pageIndex,
        pageSize,
        country
      }

      this.$request('get', dealerList, query).then((res) => {
        if (res) {
          const { data, columns, total } = res

          this.list = data
          this.headers = this.$utils.generateColumns(columns)
          this.queryParams._total = total
        }
      })
    },
    changeCountry(value) {
      this.resetAddressParams()
      this.addressOptions = []
      this.getAddress(value)
    },
    resetAddressParams() {
      this.queryParams.province = undefined
      this.queryParams.city = undefined
      this.queryParams.area = undefined
    },
    getAddress(code) {
      if (!code) return

      getAddressData(code)
      .then(res => {
        const addressOptions = res || []

        this.addressOptions = addressOptions
      })
    },
    getCityOpts() {
      const {
        province
      } = this.queryParams

      const p = this.addressOptions.find(i => i.code === province)
      if (!p) {
        this.cityOpts = []
      } else {
        this.cityOpts = p.children || []
      }
    },
    changeCity() {
      this.queryParams.area = undefined
      this.$forceUpdate()
      const { city } = this.queryParams
      const p = this.cityOpts.find((i) => i.code === city)
      this.areaOpts = p.children || []
    },
    sortChange(item) {
      // 排序方法
      const { column, order } = item
      const orderString = order
        ? order === 'ascending'
          ? 'asc'
          : 'desc'
        : undefined
      const orderBy = order ? column.sortBy : undefined

      this.queryParams.order = orderString
      this.queryParams.orderBy = orderBy
      this.getList()
    },
    search() {
      this.queryParams.pageIndex = 1
      this.getList()
    },
    handleSelectionChange(val) {
      this.selection = val
    },
    // 删除
    handleDel(row) {
      this.$request('post', delDealer, { ids: [row.id] }).then((res) => {
        if (res) {
          this.$message.success(`删除成功`)
          this.getList()
        }
      })
    },
    // 批量删除
    batchDel() {
      if (this.selection.length === 0) {
        return
      }
      this.$confirm(`确认删除吗?`).then((res) => {
        let arr = []
        for (const item of this.selection) {
          arr.push(item.id)
        }
        this.$request('post', delDealer, { ids: arr }).then((res) => {
          if (res) {
            this.$message.success(`删除成功`)
            this.getList()
          }
        })
      }).catch(() => {
      })
    },
    // 新建
    openCreate() {
      this.$refs.edit.open()
    },
    openEdit(row) {
      // 编辑
      this.$refs.edit.open(row)
    },
    openView(row) {
      // 查看详情
      this.$refs.edit.open(row, true)
    },
    // 导入
    handleImrort() {
      this.$refs.importFile.show()
    },
    getImport(file) {
      // 接收导入文件信息
      const info = {
        file_id: file.fileId,
      }
      this.$request('post', importDealer, info).then((res) => {
        if (res) {
          // 导入成功
          this.$message.success(`导入成功`)
          this.getList()
        }
      })
    },
    // 导出
    handleExport() {
      const { province, city, area, id, pageIndex, pageSize, country } = this.queryParams

      let params = {
        province,
        city,
        area,
        id,
        pageIndex,
        pageSize,
        is_export: 1,
        country
      }
      this.$utils.exportFile('/api/dealer', params)
    },
    // 获取经销商 （这里在点击经销商时需要调用该接口，如果不调用，可能会导致修改了经销商，但是经销商不更改的问题）
    getDealerSelect(name = '', cb){
      this.$request('get', dealerSelect, { struct: 1, name })
      .then((res) => {
        this.dealerOptions = res

        cb(res)
      })
    }
  },
  created() {
    // this.getDealerSelect()
    store.dispatch('setCountries')
    this.getList()
  },
}
</script>

<style></style>
